import React from 'react'

function Img(props) {
  return (
    <img className={props.className} src={props.src} alt={props.alt} />
  )
}

export default Img

/*
Usage:
- Import this class into styled-component file (ex.import Imgage from 'components/common/img')
- Import styled component class into jsx file (ex.import { Img } from './styled-components')
- Import image file (ex.import Logo from 'images/logo.png')
- Now you can use like this <Img src={props.logo} alt='product-image' />
*/



// WEBPACK FOOTER //
// ./src/components/common/img/index.js